import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CallingService } from '../calling.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'mt-progressive-dialer',
    templateUrl: 'dialer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressiveDialerComponent implements OnInit {
  @Input() filtersObj: any;
  @Output() onAction = new EventEmitter<any>();
  disabledBtn: boolean;

  constructor(private callingService: CallingService, private sb: MatSnackBar) {}

  ngOnInit() {
    // const callRes = JSON.parse(sessionStorage.getItem('callingRes'));
    // if (callRes) {
    //   this.disabledBtn = true;
    // } else {
    //   this.disabledBtn = false;
    // }
  }
  startCalling() {
    this.disabledBtn = true;
    this.callingService.startCalling(this.filtersObj).subscribe(
      (res: any) => {
        this.onAction.emit(true);
      },
      err => {
        this.sb.open('this is error startProgressiveCall', 'okay', {duration: 3000});
      }
    );
  }
}
